import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SubjectManagement = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [subjectName, setSubjectName] = useState('');
  const [message, setMessage] = useState('');

  const sessionId = localStorage.getItem('currentSessionId');

  // Fetch classes of current session
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`);
        // const sessionClasses = res.data.filter(cls => cls.sessionId === sessionId);
        setClasses(res.data);
        // if (sessionClasses.length > 0) setSelectedClass(sessionClasses[0].className);
      } catch (err) {
        console.error('Error fetching classes:', err);
      }
    };
    fetchClasses();
  }, [sessionId]);

  // Fetch subjects of selected class in current session
  useEffect(() => {
    if (!selectedClass) return;

    const fetchSubjects = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/subjects/getSubjectsByClassName/${selectedClass}`,
          { params: { sessionId } }
        );
        setSubjects(res.data);
      } catch (err) {
        console.error('Error fetching subjects:', err);
      }
    };

    fetchSubjects();
  }, [selectedClass, sessionId]);

  // Add new subject
  const handleAddSubject = async () => {
    if (!subjectName) {
      alert('Enter subject name');
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/subjects/createSubject/${selectedClass}`,
        { subjectName, sessionId }
      );
      setSubjects([...subjects, res.data]);
      setSubjectName('');
      setMessage('Subject added successfully');
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error adding subject');
    }
  };

  // Delete subject
  const handleDelete = async (subject) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/subjects/deleteSubject/${selectedClass}/${encodeURIComponent(subject.subjectName)}?sessionId=${sessionId}`
      );
      setSubjects(subjects.filter(s => s.subjectName !== subject.subjectName));
      setMessage('Subject deleted successfully');
    } catch (err) {
      setMessage('Error deleting subject');
    }
  };

  const labelStyle = "block text-black font-semibold text-[18px] mb-2";
  const inputStyle = "border border-gray-300 rounded-lg p-2 mt-1 w-full text-[14px]";

  return (
    <div className="min-h-v-100 p-6">
      <div className="max-w-7xl mx-auto">

        {/* Class Select */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-6">
          <label className={labelStyle}>Select Class:</label>
          <select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            className={inputStyle}
          >
            {classes.map(c => (
              <option key={c.classId} value={c.className}>{c.className}</option>
            ))}
          </select>
        </div>

        {/* Create Subject */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-8">
          <h2 className="font-semibold text-black text-[18px] mb-4">Create New Subject</h2>
          <input
            type="text"
            className={inputStyle}
            placeholder="Enter subject name"
            value={subjectName}
            onChange={(e) => setSubjectName(e.target.value)}
          />
          <button
            className="bg-blue-800 text-white rounded-lg px-4 py-2 mt-4"
            onClick={handleAddSubject}
          >
            Save Subject
          </button>
          {message && <p className="mt-4 text-red-500">{message}</p>}
        </div>

        {/* Subjects List */}
        <div className="bg-white shadow-md rounded-lg p-6">
          <h2 className="font-semibold text-black text-[18px] mb-4">List of Subjects</h2>
          <table className="min-w-full bg-white text-center border border-gray-300 rounded-lg">
            <thead className="bg-gray-200">
              <tr>
                <th className="py-2 px-4 border-b">Sr. No.</th>
                <th className="py-2 px-4 border-b">Subject Name</th>
                <th className="py-2 px-4 border-b">Action</th>
              </tr>
            </thead>
            <tbody className="bg-gray-50">
              {subjects.map((subject, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="border px-4 py-2">{index + 1}</td>
                  <td className="border px-4 py-2">{subject.subjectName}</td>
                  <td className="border px-4 py-2">
                    <button
                      className="bg-red-600 text-white rounded-lg px-4 py-2"
                      onClick={() => handleDelete(subject)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {subjects.length === 0 && (
                <tr>
                  <td colSpan="3" className="py-4 text-gray-500">No subjects found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default SubjectManagement;